<template>
  <div class="page">
    <div class="app-container">
      <el-form
        ref="dataForm"
        :model="temp"
        label-position="left"
        label-width="70px"
        style="width: 50%"
      >
        <el-form-item label="角色" prop="group_id">
          <el-input v-model="group" :disabled="true" />
        </el-form-item>
        <el-form-item label="账号" prop="username">
          <el-input v-model="name" :disabled="true" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="temp.password"
            clearable
            placeholder="不修改，则留空"
          />
        </el-form-item>
        <el-form-item class="from-item--30" label="头像" prop="img">
          <el-upload class="avatar-uploader"
            :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img"
            :show-file-list="false"
            :headers="{token: getToken(),}" :data="{path: 20,}" :on-change="(file) => handleChangeFile(file, 'company_logo')" >
            <img v-if="temp.img" :src="temp.img" class="avatar"/>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="姓名" prop="realname">
          <el-input v-model="temp.realname" clearable />
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model="temp.phone" clearable />
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="temp.email" clearable />
        </el-form-item>
      </el-form>
      <el-button :loading="btnLoading" type="primary" @click="saveData()"
        >保存</el-button
      >
    </div>
  </div>
</template>

<script>
import Uploadone from "@/components/Upload/singleImage";
import { modify } from "@/api/user";
import { mapGetters } from "vuex";
import store from "@/store";
import myconfig from "@/settings.js";
import { getToken } from "@/utils/auth";

export default {
  name: "MyInfo",
  components: { Uploadone },
  data() {
    return {
      btnLoading: false,
      temp: {
        password: "",
        realname: store.getters.realname,
        phone: store.getters.phone,
        email: store.getters.email,
        img: store.getters.avatar,
      },
      config: {
        fileName: "img",
        multiple: true,
        accept: "image/*",
        action: myconfig.uploadUrl.img,
      },
      header: {
        "x-access-appid": myconfig.appid,
        token: getToken(),
      },
    };
  },
  computed: {
    ...mapGetters(["name", "group"]),
  },
  watch: {
    temp: {
      handler() {},
      immediate: true,
      deep: true,
    },
  },
  created() {},
  destroyed() {},
  methods: {
    async handleChangeFile(file,key) {
      this.loading = true;
      const fd = new FormData();
      fd.append("img", file.raw);
      fd.append("path", "20");
      const res = await this.$api.upload("/admin/upload/upimg", fd);
      if (res.code === 10000) {
        this.$message.success("上传成功");
        this.temp.img = res.data.path;
      } else {
        this.$message.error(res.msg);
      }
      this.loading = false;
    },
    getToken,
    saveData() {
      this.btnLoading = true;
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          const _this = this;
          modify(this.temp)
            .then((response) => {
              if (response.status === 1) {
                store.commit("SET_AVATAR", _this.temp.img);
                store.commit("SET_REALNAME", _this.temp.realname);
                store.commit("SET_PHONE", _this.temp.phone);
                store.commit("SET_EMAIL", _this.temp.email);
                _this.$message.success(response.msg);
              } else {
                _this.$message.error(response.msg);
              }
              _this.btnLoading = false;
              // eslint-disable-next-line handle-callback-err
            })
            .catch(() => {
              this.btnLoading = false;
            });
        } else {
          this.btnLoading = false;
        }
      });
    },
  },
};
</script>
<style>
  .avatar {
	  width: 50px;
	  height: 50px;
	  display: block;
	}
  .avatar-uploader-icon {
	  font-size: 28px;
	  color: #8c939d;
	  width: 50px;
	  height: 50px;
	  line-height: 50px;
	  text-align: center;
	}
</style>